import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  If,
  Message,
  Produktbaustein,
  updateWindowHeightForIF,
  trEnv,
  appActions,
  FormSelect,
  replaceEURinValueSet,
} from 'ion-lib';
import i18next from 'i18next';
import { setBeratersuche } from '../../../helper';

const Naturgefahr = ({
  baustein,
  bausteinIndex,
  handleChange,
  handleChangeSelbstbehalt,
  selbstbehalt,
}) => {
  const [showAlert, setAlert] = useState(true);

  const dispatch = useDispatch();
  const wagnis = useSelector((state) => state.daten.wagnis);
  const medial = (!trEnv.stationaer && (trEnv.istOESA || trEnv.istOEVO)) || trEnv.medial;
  const compareGkWith = (value) => parseInt(wagnis.gk.value, 10) === value;

  return (
    baustein.relevant && (
      <Produktbaustein
        title="Schutz vor Naturgefahren"
        onClick={() => {
          if (!baustein.ueberschreibbar && !showAlert) {
            setAlert(true);
          }
        }}
        tooltip={() => dispatch(appActions.toggleModal(i18next.t('produktvergleich.zusatz.naturgefahren_tt')))}
        onChange={handleChange}
        name={`daten.bausteine.${bausteinIndex}.naturgefahren.value`}
        checkbox={baustein}
      >
        <div dangerouslySetInnerHTML={{ __html: i18next.t('produktvergleich.zusatz.naturgefahren_beschreibung') }} />

        {/* Alert Baustein deaktiviert */}
        <If predicate={!baustein.value && baustein.ueberschreibbar}>
          <Message
            show
            dismissible
            onAfterClose={() => {
              updateWindowHeightForIF();
            }}
            text="<p>Wir empfehlen Ihnen die Absicherung gegen weitere Naturgefahren (Elementarschäden). Sind Sie sich sicher, dass Sie auf diesen zusätzlichen Versicherungsschutz verzichten möchten?</p>"
            variant="dark"
          />
        </If>

        {/* Alert medial GK0 */}
        <If predicate={medial && compareGkWith(0) && showAlert}>
          <Message
            show
            dismissible
            onAfterClose={() => {
              setAlert(false);
              updateWindowHeightForIF();
            }}
            text={setBeratersuche('produktvergleich.zusatz.naturgefahren_alert_gk0', wagnis)}
            variant="dark"
          />
        </If>

        {/* Alert IFiliale GK0, nur für VGH und ÖVB */}
        <If predicate={trEnv.ifiliale && (trEnv.istVGH || trEnv.istOEVB) && showAlert && compareGkWith(0)}>
          <Message
            show
            dismissible
            onAfterClose={() => {
              setAlert(false);
              updateWindowHeightForIF();
            }}
            text={setBeratersuche('produktvergleich.zusatz.naturgefahren_alert_gk0_if', wagnis)}
            variant="dark"
          />
        </If>

        {/* Alert stationaer GK0 */}
        <If predicate={trEnv.stationaer && compareGkWith(0) && baustein.value}>
          <Message
            show
            dismissible
            onAfterClose={() => {
              updateWindowHeightForIF();
            }}
            text={setBeratersuche('produktvergleich.zusatz.naturgefahren_alert_gk0_stat', wagnis)}
            variant="dark"
          />
        </If>

        {/* Alert medial GK4 und ÖSA GK3 */}
        <If predicate={medial && (compareGkWith(4) || (compareGkWith(3) && trEnv.istOESA)) && showAlert}>
          <Message
            show
            dismissible
            onAfterClose={() => {
              setAlert(false);
              updateWindowHeightForIF();
            }}
            text={setBeratersuche('produktvergleich.zusatz.naturgefahren_alert_gk4', wagnis)}
            variant="dark"
          />
        </If>

        {/* Alert IFiliale GK4, nur für VGH und ÖVB */}
        <If predicate={trEnv.ifiliale && (trEnv.istVGH || trEnv.istOEVB) && showAlert && compareGkWith(4)}>
          <Message
            show
            dismissible
            onAfterClose={() => {
              setAlert(false);
              updateWindowHeightForIF();
            }}
            text={setBeratersuche('produktvergleich.zusatz.naturgefahren_alert_gk4_if', wagnis)}
            variant="dark"
          />
        </If>

        {/* Alert stationaer GK4 */}
        <If predicate={trEnv.stationaer && compareGkWith(4) && (((trEnv.istVGH || trEnv.istOEVB) && baustein.value) || ((trEnv.istOESA || trEnv.istOEVO) && showAlert))}>
          <Message
            show
            dismissible
            onAfterClose={() => {
              setAlert(false);
              updateWindowHeightForIF();
            }}
            text={setBeratersuche('produktvergleich.zusatz.naturgefahren_alert_gk4_stat', wagnis)}
            variant="dark"
          />
        </If>

        {/* Alert ÖSA stationaer GK2 und GK3, ZÜRS Hinweis */}
        <If predicate={trEnv.stationaer && (compareGkWith(2) || compareGkWith(3)) && trEnv.istOESA && baustein.value}>
          <Message
            show
            dismissible
            onAfterClose={() => {
              updateWindowHeightForIF();
            }}
            text={setBeratersuche('produktvergleich.zusatz.naturgefahren_alert_gk23_stat', wagnis)}
            variant="dark"
          />
        </If>

        <If predicate={selbstbehalt.relevant}>
          <FormSelect
            {...selbstbehalt}
            valueSet={replaceEURinValueSet(selbstbehalt.valueSet)}
            label={i18next.t('produktvergleich.zusatz.naturgefahren_sb_label')}
            subtitle="Reduzieren Sie Ihren Beitrag!"
            labelClassName="fb-100 text-start"
            className="produktbaustein__auswahl mb-5"
            onChange={handleChangeSelbstbehalt}
            name={`daten.bausteine.${bausteinIndex}.selbstbehaltElementar.value`}
            tooltip={() => dispatch(appActions.toggleModal(i18next.t('produktvergleich.zusatz.naturgefahren_sb_tt')))}
            message={selbstbehalt.warning && `<p>${selbstbehalt.warning}</p>`}
            flex
          />
        </If>
      </Produktbaustein>
    )
  );
};

export default Naturgefahr;
